import { createContext } from 'react';
import { Provider } from 'react-redux';
import { configureStore } from 'forms-ai-lib/internal/configureStore';
import { jsx as _jsx } from "react/jsx-runtime";
export const Context = /*#__PURE__*/createContext(
// @ts-expect-error Initializing to null for simplicity, a provider should always be present
null);
const store = configureStore();
export const ReduxStoreProvider = ({
  children
}) => /*#__PURE__*/_jsx(Provider, {
  store: store,
  context: Context,
  children: children
});
export function makeTestStoreAndProvider(preloadedState) {
  const testStore = configureStore(preloadedState);
  return {
    store: testStore,
    Provider: ({
      children
    }) => /*#__PURE__*/_jsx(Provider, {
      store: testStore,
      context: Context,
      children: children
    })
  };
}